"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_LOCATION_ID = exports.EMPTY_ADDRESS = exports.LOCATION_ID_UB = exports.CONTRACT_PRECISION = void 0;
const big_integer_1 = __importDefault(require("big-integer"));
/**
 * The precision of Energy & Silver stored in the Dark Forest smart contracts.
 *
 * Energy and Silver are not stored as floats in the smart contracts,
 * so any of those values coming from the contracts need to be divided by `CONTRACT_PRECISION`
 * and any values being sent to the contract need to be multiplied by `CONTRACT_PRECISION`.
 */
exports.CONTRACT_PRECISION = 1000;
/**
 * The upper-bounds of a LocationID.
 *
 * Represents the maximum possible value that the MiMC hash function (used for IDing locations in the universe) can output.
 * A LocationID must be less than `LOCATION_ID_UB / PLANET_RARITY` in order to be considered a valid planet.
 */
exports.LOCATION_ID_UB = big_integer_1.default('21888242871839275222246405745257275088548364400416034343698204186575808495617');
/**
 * The 0x0 Ethereum address, which is used for unowned planets, artifacts without an owner, etc.
 */
exports.EMPTY_ADDRESS = '0x0000000000000000000000000000000000000000';
/**
 * A blank LocationID (all zeros).
 */
exports.EMPTY_LOCATION_ID = '0000000000000000000000000000000000000000000000000000000000000000';
